import { Plugin } from "..";

const id = "mediaplayer";

export const MediaPlayer: Plugin = {
	id,
	type: "event",
	header: {
		visible: false,
		edit: true,
		fullscreen: false,
	},
	name: "mediaPlayer",
	component: defineAsyncComponent(() => import("./MediaPlayerPlugin")),
	config: defineAsyncComponent(() => import("./MediaPlayerPluginConfig.vue")),
	dataConfig: null,
	defaultDataResolver: () => undefined,
	defaultOptionsResolver: () => undefined,
	dimension: {
		minHeight: 2,
		minWidth: 6,
	},

	currentVersion: 1,
	migrations: {},
};
